document.addEventListener("DOMContentLoaded", function(){
    //Get the overlay
    const menuOverlay = document.querySelector('.menu-overlay');
    menuOverlay.addEventListener('click',function (event){
        const signInButton = document.getElementById('signInDesktop');
        if(signInButton.getAttribute('aria-expanded') === 'true') signInButton.click();
    },false);
    var togglesOpen = 0;

    //Get the Nav Links that trigger showing and hidding the overlays in Desktop
    document.querySelectorAll('.nav-link.dropdown-toggle').forEach(function(menuToggle){
        menuToggle.addEventListener('shown.bs.dropdown', function () {
            togglesOpen++;
            evalTogglesOpen();
        });

        menuToggle.addEventListener('hide.bs.dropdown', function () {
            togglesOpen--;
            evalTogglesOpen();
        });
    });

    //Get the mobile menu toggler (#navContent) and sign In collapses that triggers show and hiding the overlay
    document.querySelectorAll('#signInDesktopCollapse, #signInMobileCollapse, #navContent').forEach( function (collapse){
        collapse.addEventListener('show.bs.collapse', function () {
            togglesOpen++;
            evalTogglesOpen();
        });
        collapse.addEventListener('hide.bs.collapse', function () {
            togglesOpen--;
            evalTogglesOpen();
        });
    });

    //Desktop - When opening a dropdown when another is open, the order in which Bootstrap runs is odd. We need this helper to handle this.
    function evalTogglesOpen(){
        if(togglesOpen > 0){
            menuOverlay.classList.add('show');
        }else{
            menuOverlay.classList.remove('show');
        }
    }
});

//Reset main padding top based on the header height on mobile to handle varying sizes of breadcrumbs and alerts
const resizeObserver = new ResizeObserver(entries => {
    let height = -1;
    for (let entry of entries) {
        if (entry.contentBoxSize) {
            // The standard makes contentBoxSize an array...
            if (entry.contentBoxSize[0]) {
                height = entry.contentBoxSize[0].blockSize;
            } else {
                // ...but old versions of Firefox treat it as a single item
                height = entry.contentBoxSize.blockSize;
            }
        } else {
            height = entry.contentRect.height;
        }
    }
    if(height>=0 && window.matchMedia("(max-width: 991.98px)").matches) {
        document.querySelector('div.main').style.paddingTop = height + 'px';
    }else{
        document.querySelector('div.main').style.removeProperty('padding-top');
    }
});
resizeObserver.observe(document.querySelector('.amerant-header'));